// @flow

import React, { Component } from 'react';

import ChatMessage from './ChatMessage';
import ChatMessageGroup from './ChatMessageGroup';

class RPC_ChatMessageGroup extends ChatMessageGroup {
    
    render() {
        const { className, messages } = this.props;

        const messagesLength = messages.length;

        if (!messagesLength) {
            return null;
        }

        return (
            <div className = { `chat-message-group ${className}` }>
                {
                    messages.map((message, i) => (
                        <ChatMessage
                            key = { i }
                            message = { message }
                            showDisplayName = { i === 0 || true }
                            showTimestamp = { i === messages.length - 1 || true } />
                    ))
                }
            </div>
        );
    }
}

export default RPC_ChatMessageGroup;
